import { Routes, Route, Navigate } from 'react-router-dom';
import { Container, Box } from '@mui/material';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import TariffList from './components/TariffList';
import TariffDetail from './components/TariffDetail';
import TemplateEditor from './components/TemplateEditor';
import ReauthBanner from './components/ReauthBanner';

function App() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <ReauthBanner />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Container maxWidth="xl" sx={{ py: 4 }}>
                <TariffList />
              </Container>
            </ProtectedRoute>
          }
        />
        <Route
          path="/tariff/:tariffId"
          element={
            <ProtectedRoute>
              <Container maxWidth="xl" sx={{ py: 4 }}>
                <TariffDetail />
              </Container>
            </ProtectedRoute>
          }
        />
        <Route
          path="/editor/:tariffId/:variantType"
          element={
            <ProtectedRoute>
              <TemplateEditor />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Box>
  );
}

export default App;
